import { connect, ConnectedProps } from 'react-redux';
import { StateType } from '../../../state/reducers';

const mapState = ({ queryParams, search }: StateType) => ({
  type: queryParams.type,
  enableTypeSelector: search.enableTypeSelector,
});

export const Connect = connect(mapState);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
